import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import {arbitrum, defineChain, mainnet} from "@reown/appkit/networks";
import Bnb from "../assets/imgs/chain/bnb.png";

// 1. Get projectId
const projectId = "0718b6a27bd16c05e5c58b01d417a43e";


// 3. Create a metadata object - optional
const metadata = {
    name: "AAEC",
    description: "AAEC Dapp",
    url: "https://aaec.io", // AAEC线上网址
    icons: ["%PUBLIC_URL%/logo192.png"],
};

// define BSC network
// Define the custom network
const BscNetwork = defineChain({
    id: 56,
    caipNetworkId: 'eip155:56',
    chainNamespace: 'eip155',
    name: 'Binance Smart Chain',
    nativeCurrency: {
        decimals: 18,
        name: 'Binance Coin',
        symbol: 'BNB',
    },
    rpcUrls: {
        // https://bsc.meowrpc.com
        // wss://bsc-rpc.publicnode.com
        default: {
            http: ['https://bsc-dataseed.binance.org'],
            webSocket: ['wss://bsc-rpc.publicnode.com'],
        },
    },
})

// 2. Set the networks
const networks = [BscNetwork, arbitrum, mainnet];

// 4. Create a AppKit instance
const init = () => createAppKit({
    adapters: [new EthersAdapter()],
    networks,
    metadata,
    projectId,
    features: {
        analytics: true, // Optional - defaults to your Cloud configuration
        connectMethodsOrder: ["wallet"],
    },
    themeVariables: {
        "--w3m-accent": "#1DE3C2",
    },
    chainImages: {
        "56": Bnb
    }
});

export default init;
